import { MATH_ROUND } from "../constants/operationsWithNumbers";

export const roundNumber = (value: number) => {
    return Math.round(value * MATH_ROUND) / MATH_ROUND;
}